const fromIriToId = (iri: string | undefined | null): string | undefined =>
  iri ? iri.split('/').pop() : undefined;

export const apiUtils = {
  fromIriToId,
};
